<script>
import { isEmail } from "lib/modules/Validate";

export default {
	props: {
		error: {
			type: String,
			default: null,
			required: false
		},
		minlength: {
			type: [Number, String],
			default: null,
			required: false
		},
		pattern: {
			type: RegExp,
			default: null,
			required: false
		},
		patternError: {
			type: String,
			default: null,
			required: false
		},
		required: {
			type: Boolean,
			default: false,
			required: false
		}
	},
	watch: {
		error() {
			this.validate();
		},
		minlength() {
			this.validate();
		},
		patternError() {
			this.validate();
		},
		required() {
			this.validate();
		},
		value() {
			this.validate();
		}
	},
	methods: {
		_validate() {
			const value = this.value === null ? "" : String(this.value);

			if (value.length > 0 && this.pattern && !this.pattern.test(value))
				return this.patternError || `Invalid ${this.label}`;
			else if (this.required && value.length === 0)
				return `${this.label} is required`;
			else if (this.minlength && value.length < parseInt(this.minlength))
				return `${this.label} is too short`;
			else if (value.length > 0 && this.type === "email" && !isEmail(value))
				return "Invalid e-mail address";
			else if (this.error)
				return this.error;

			return null;
		}
	}
};
</script>
